module.exports = __webpack_public_path__ + "img/vertical_6_1_8003.b2f03b48.png";